// extracted by mini-css-extract-plugin
export var addressFields = "_gd-0";
export var animationContainer = "_gd-1";
export var footer = "_gd-2";
export var lineItems = "_gd-3";
export var modalContent = "_gd-4";
export var orderName = "_gd-5";
export var strong = "_gd-6";
export var warning = "_gd-7";